export const FETCH_WHATSAPP_CHARGES_REQUEST = "FETCH_WHATSAPP_CHARGES_REQUEST";
export const FETCH_WHATSAPP_CHARGES_SUCCESS = "FETCH_WHATSAPP_CHARGES_SUCCESS";
export const FETCH_WHATSAPP_CHARGES_FAILURE = "FETCH_WHATSAPP_CHARGES_FAILURE";
export const FETCH_WHATSAPP_CHARGES_RESET = "FETCH_WHATSAPP_CHARGES_RESET";
export const fetchWhatsappChargesRequest = (payload) => ({
    type: FETCH_WHATSAPP_CHARGES_REQUEST,
    payload,
});
export const fetchWhatsappChargesSuccess = (payload) => ({
    type: FETCH_WHATSAPP_CHARGES_SUCCESS,
    payload,
});
export const fetchWhatsappChargesFailure = (payload) => ({
    type: FETCH_WHATSAPP_CHARGES_FAILURE,
    payload,
});
export const fetchWhatsappChargesReset = () => ({
    type: FETCH_WHATSAPP_CHARGES_RESET,
});
